export enum ErrorCode {
    Failed = 0,
    Success = 1,
}